// Central place to track app version and a lightweight changelog.
// Bump APP_VERSION for weekly/monthly releases (e.g., v1, v1.1, v1.2).
// Optionally override at build time with Vite env var VITE_APP_VERSION.

const versionFromEnv =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_APP_VERSION) ||
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_VERSION);

export const APP_VERSION = versionFromEnv || "v1 (dev)";

// Recent changes worth surfacing inline. Keep brief, newest first.
export const CHANGELOG = [
  {
    v: "v1.1",
    date: "2025-09-17",
    notes: [
      "Global version badge (sidebar + mobile top bar) and in-app changelog",
      "Login page shows app version",
      "Printed invoice footer shows app version",
      "Retro dropdown shows phone numbers; payments list Retro badge uses friendly line labels",
      "Build automation: prebuild script sets REACT_APP_VERSION and syncs package.json",
    ],
  },
  {
    v: "v1 (dev)",
    date: "2025-09-17",
    notes: [
      "Restored Retro Billing with reason, amount, and optional line selector",
      "Added Retro badge in payments list and invoice note",
      "Shipping auto-fill from customer, presets, carrier, and inline validation",
      "Invoice prints carrier/service + retro line label when available",
    ],
  },
];

// How to set a release build version:
// - Create a .env file with: REACT_APP_VERSION=v1.1
//   or pass it in your build command (CI): REACT_APP_VERSION=v1.1 npm run build
// - Then bump CHANGELOG with a new entry.
